import { ReactElement } from 'react';
import styled from 'styled-components'

import { Spinner } from '@toqio/toqio-web-components'
import { spacing } from 'styles/spacing'
import { SpinnerProps, PageSpinnerProps, SmallSpinnerProps } from './loading.types'


/** LOADING */
export const Loading = ({ color = '', size = 80, className = '', style = {} }: SpinnerProps): ReactElement => (
  <Spinner
    color={color}
    size={size}
    className={className}
    style={{ margin: 0, ...style }} // Add margin: 0; to avoid default auto
  />
)

/** SMALL LOADING */
export const SmallLoading = ({ color = '', className = '', style = {} }: SmallSpinnerProps): ReactElement => (
  <Loading
    size={20}
    color={color}
    className={className}
    style={style}
  />
)


/** PAGE LOADING */
const StyledPageContainer = styled.div`
  display-flex: flex; 
  flex: 1;
  align-items: center;
  justify-content: center;
  ${spacing('my', 12)}
`

export const PageLoading = ({ color = '', size = 80, containerClassName = '', className = '', style = {} }: PageSpinnerProps): ReactElement => (
  <StyledPageContainer className={containerClassName}>
    <Spinner
      color={color}
      size={size}
      className={className}
      style={style}
    />
  </StyledPageContainer>
)